import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { Flex, Text } from '@chakra-ui/react';

function StatBlock({ data }) {
  const { content } = data || {};
  return (
    <Flex
      direction='column'
      align='center'
      padding='30px 0'
      margin='20px 0'
      textAlign='center'
      borderTop='4px solid'
      borderBottom='4px solid'
      borderColor='orange'
      color='black'
    >
      {content?.map(({ _key, beforeText, number, afterText, prefix, suffix, emphasis }) => (
        <div key={_key}>
          {beforeText && <Text fontWeight={600}>{beforeText}</Text>}
          {number ? (
            <VisibilitySensor>
              {({ isVisible }) => (
                <CountUp
                  end={number}
                  duration={1.5}
                  start={isVisible}
                  delay={0}
                  decimals={countDecimalPoints(number)}
                  prefix={prefix !== undefined ? prefix : ''}
                  suffix={suffix !== undefined ? suffix : ''}
                  separator=','
                >
                  {({ countUpRef }) => (
                    <Text
                      fontSize='6xl'
                      lineHeight={1.1}
                      fontWeight={600}
                      ref={countUpRef}
                      color='orange'
                      mt={0}
                    />
                  )}
                </CountUp>
              )}
            </VisibilitySensor>
          ) : (
            <Text fontSize='6xl' lineHeight={1.1} fontWeight={600} mt={0}>
              {prefix !== undefined ? prefix : ''}
              {suffix !== undefined ? suffix : ''}
            </Text>
          )}
          {emphasis && (
            <Text fontSize='6xl' lineHeight={1.1} fontWeight={600} color='orange'>
              {emphasis}
            </Text>
          )}
          {afterText && (
            <Text fontWeight={600} marginTop={0}>
              {afterText}
            </Text>
          )}
        </div>
      ))}
    </Flex>
  );
}

function countDecimalPoints(number) {
  // Convert the number to a string
  const numberString = number.toString();

  // Find the position of the decimal point
  const decimalIndex = numberString.indexOf('.');

  // If there is no decimal point, return 0
  if (decimalIndex === -1) {
    return 0;
  }

  // Calculate the number of decimal points
  const decimalPoints = numberString.length - decimalIndex - 1;

  // Return the result
  return decimalPoints;
}

export default StatBlock;
